import { federalCssStylesEnabled as isFederalInstance } from '@gonfalon/constants/constants';
import { NewTabLink } from '@gonfalon/launchpad-experimental/NewTabLink';

import { trackCreateSupportTicket } from './trackCreateSupportTicket';

type CreateSupportTicketLinkProps = {
  onClick?: () => void;
  identifierForAnalyticsTracking?: string;
  hideIcon?: boolean;
  text?: string;
};

export const CreateSupportTicketLink = ({
  onClick,
  identifierForAnalyticsTracking = '',
  hideIcon = false,
  text = 'create a support ticket',
}: CreateSupportTicketLinkProps) => {
  const handleClick = () => {
    onClick?.();
    trackCreateSupportTicket(identifierForAnalyticsTracking);
  };

  const SUPPORT_TICKET_URL = isFederalInstance()
    ? 'https://support.launchdarkly.us'
    : 'https://support.launchdarkly.com';

  return (
    <NewTabLink
      href={`${SUPPORT_TICKET_URL}/hc/en-us/requests/new`}
      onClick={handleClick}
      text={text}
      showIcon={!hideIcon}
    />
  );
};
